import IconButton from '@material-ui/core/IconButton'
import { makeStyles, styled } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    minHeight: 'calc(100vh - 72px)',
    overflowY: 'hidden',
  },
  breadcrumbs: {
    padding: '40px 0px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0px',
    },
  },
  searchContent: {
    paddingBottom: theme.spacing(2),
  },
  searchField: {
    width: '100%',
    margin: '40px 0 60px 0',
  },
  refineAndHide: {
    marginBottom: '40px',
  },
  filterAndSort: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column',
  },
  hideFiltersFlex: {
    fontWeight: 600,
    margin: '0px 5px',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
  },
  mapFlex: {
    fontWeight: 600,
    margin: '0px 5px 0px 10px',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
  },
  bggShowAllBtn: {
    padding: 0,
    height: '20px',
  },
  mapBtn: {
    [theme.breakpoints.up('md')]: {
      marginRight: '10px',
    },
  },
  sortBoxStyles: {
    fontWeight: 600,
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: '0px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  resultsTxt: {
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      paddingBottom: '10px',
    },
  },
  mapViewMapContainer: {
    height: 'calc(100vh - 155px)',
    overflowY: 'hidden',
  },
  switcher: {
    position: 'absolute',
    width: '96px',
    borderRadius: '24px',
    bottom: '50px',
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    zIndex: 10000,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}))

export const StyledIconButton = styled(IconButton)({
  '&:hover': {
    borderRadius: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
})
